<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:titleEnd>
			<sf-button v-if="isButton_(scrId, 'CU')" size="lg" color="default" :line="false" :onClick="() => Copy()">Copy</sf-button>
			<!-- copy -->
		</template>
		<template v-slot:content>
			<center-content ref="content" :Add="Add" :Save="Save" :Delete="Delete" :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupControlManagement/store/helpers';
import CenterContent from './Content/Content.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		CenterContent
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Add() {
			this.$refs.content.$refs.funcListPopupContainer.open();
		},
		Save() {
			this.$refs.content.$refs.table.saveClick();
		},
		Delete() {
			this.$refs.content.$refs.table.deleteClick();
		},
		Copy() {
			this.$refs.content.$refs.copyPopupContainer.open();
		},
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>

<style></style>
